import React, { useState } from 'react';

export function ImageViewer({ images, initialIndex = 0, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  
  if (!images || images.length === 0) return null;
  
  const handlePrev = (e) => { e.stopPropagation(); setCurrentIndex(prev => prev > 0 ? prev - 1 : images.length - 1); };
  const handleNext = (e) => { e.stopPropagation(); setCurrentIndex(prev => prev < images.length - 1 ? prev + 1 : 0); };

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, zIndex: 100, background: 'rgba(0,0,0,0.9)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    }}>
      {/* Close button */}
      <button onClick={onClose} style={{
        position: 'absolute', top: '16px', right: '16px', width: '40px', height: '40px',
        borderRadius: '50%', background: 'rgba(255,255,255,0.2)', border: 'none',
        color: '#FFF', fontSize: '20px', cursor: 'pointer', zIndex: 101,
      }}>✕</button>

      {/* Image */}
      <img
        src={images[currentIndex]}
        alt=""
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '90vw', maxHeight: '75vh', objectFit: 'contain', borderRadius: '8px' }}
      />

      {/* Navigation arrows */}
      {images.length > 1 && (
        <>
          <button onClick={handlePrev} style={{
            position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)',
            width: '44px', height: '44px', borderRadius: '50%', background: 'rgba(255,255,255,0.2)',
            border: 'none', color: '#FFF', fontSize: '20px', cursor: 'pointer',
          }}>‹</button>
          <button onClick={handleNext} style={{
            position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
            width: '44px', height: '44px', borderRadius: '50%', background: 'rgba(255,255,255,0.2)',
            border: 'none', color: '#FFF', fontSize: '20px', cursor: 'pointer',
          }}>›</button>
        </>
      )}

      {/* Counter + category label */}
      <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
        <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>
          {currentIndex + 1} / {images.length}
        </span>
        {/* Thumbnail strip */}
        {images.length > 1 && (
          <div style={{ display: 'flex', gap: '6px', overflowX: 'auto', maxWidth: '90vw', padding: '4px' }}>
            {images.map((img, idx) => (
              <img
                key={`thumb-${idx}`}
                src={img}
                alt=""
                onClick={(e) => { e.stopPropagation(); setCurrentIndex(idx); }}
                style={{
                  width: '48px', height: '48px', objectFit: 'cover', borderRadius: '6px', cursor: 'pointer',
                  border: idx === currentIndex ? '2px solid #D4AF37' : '2px solid transparent',
                  opacity: idx === currentIndex ? 1 : 0.5,
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ImageViewer;
